/* Adding eslint-disable-line because eslint complaints that this should be a default export
 once more selectors are added, it can be removed */
export const getModuleGroup = (state, props) => state.moduleGroup[props.tag]; // eslint-disable-line



/** WEBPACK FOOTER **
 ** ./src/selectors/promotions/SmallTopBanner.js
 **/